import { IoIosClose } from 'react-icons/io';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import { EditHeader } from './styled';
import MoveStoryPage from '../move';

const EditButtons = ({ storyId }) => (
  <MoveStoryPage.Consumer>
    {({ moveStoryPageId, resetMoveStoryPage }) => moveStoryPageId && (
      <EditHeader
        bg={moveStoryPageId ? 'brand' : 'white'}
        color={moveStoryPageId ? 'white' : 'inherit'}
      >
        <>
          <button
            type="button"
            onClick={() => resetMoveStoryPage()}
            style={{
              fontSize: '2em',
              color: 'white',
              lineHeight: 1,
            }}
          >
            <IoIosClose />
          </button>
          <span style={{ margin: 'auto' }}>Click ‘Move here’ where you want this media placed</span>
        </>
      </EditHeader>
    )}
  </MoveStoryPage.Consumer>
);

EditButtons.propTypes = {
  storyId: PropTypes.string.isRequired,
};

export default EditButtons;
